import { useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { videosRequiringAlignmentCheckAtom } from '../atoms/videoAlignmentRequired';
import convertKeys from '../utils/convertKeys';
import { filterEventsWithNoVideoReference } from '../utils/videoReference';

/**
 * Loads the passed in video references into the videos requiring alignment check atom.
 * The video references must contain the following keys: matchId, period, sport, track, version.
 */
export const useVideoDataForAlignmentCheck = (videos) => {
  const setVideosRequiringAlignmentCheckAtom = useSetAtom(
    videosRequiringAlignmentCheckAtom,
  );
  const eventsWithVideoReference = useMemo(
    () => filterEventsWithNoVideoReference(convertKeys(videos)),
    [videos],
  );

  useEffect(() => {
    if (!videos || eventsWithVideoReference.length === 0) {
      return undefined;
    }

    if (eventsWithVideoReference.length > 0) {
      const eventsForAlignment = eventsWithVideoReference.map(
        ({
          matchId,
          period,
          matchPart,
          sport,
          track,
          version,
          ...videoInfo
        }) => ({
          videoInfo: {
            ...videoInfo,
            periodStart: videoInfo?.periodStart || videoInfo?.kickoff,
          },
          videoReference: {
            matchId,
            period: period || matchPart,
            sport,
            track,
            version,
          },
        }),
      );

      setVideosRequiringAlignmentCheckAtom(eventsForAlignment);
    }
    return () => setVideosRequiringAlignmentCheckAtom([]);
  }, [eventsWithVideoReference]);
};

export default useVideoDataForAlignmentCheck;
